// extracted by mini-css-extract-plugin
export default {"instructions":"ReferralInstructionsBlock_instructions"};